/* Exemple de classe */
class Accordions {
	constructor() {

		this.dom = {
			header: $(".js-accordion-header")
		};

		if (!this.dom.header.length) return;

		this.init();
	}

	init() {
		this.dom.header.on("click", e => {
			const $el = $(e.currentTarget);
			$el.toggleClass("is-active");
			$el.next().slideToggle();
		});
	}
}
